import styled from '@emotion/styled';

const defaultWidth = 1100;

export const PDFViewerContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	height: 100%;
	width: 100%;
	align-items: center;
	position: relative;

	padding: 20px 20px 0;
`;

export const DocumentContainer = styled.div<{ scale: string }>`
	overflow-x: hidden;
	width: 100%;
	height: 100%;
	max-width: ${defaultWidth}px;

	transform-origin: left top;
	box-sizing: border-box;

	scale: ${props => props.scale};
`;
